module.exports = __webpack_public_path__ + "img/dreams-mini-portrait.5a25aa3.png";